import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IUISlice {
  processingOrder: boolean
  copyToAllCarts: boolean
}

const initialState: IUISlice = {
  processingOrder: false,
  copyToAllCarts: false,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setProcessingOrder: (state, action: PayloadAction<boolean>) => {
      state.processingOrder = action.payload
    },
    setCopyToAllCarts: (state, action: PayloadAction<boolean>) => {
      state.copyToAllCarts = action.payload
    },
  },
})

export const { setProcessingOrder, setCopyToAllCarts } = uiSlice.actions
export { uiSlice }
